module.exports = __webpack_public_path__ + "images/init-progress-65d3d5ec9d4626319a0e4dbee6f41f4b.png";